import mutation from './mutation'
import action from './action'
import getter from './getter'
export default {
  namespaced: true,
  state: {
    publishedArticles: {
      total: '',
      module: '',
      start_date: '',
      end_date: ''
    },
    publishedArticleState: false
  },
  getters: getter,
  mutations: mutation,
  actions: action,
  modules: {}
}
